/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Column_TldInputs */

const id_tld_pricing_column_tld = /** @type {(inputs: Tld_Pricing_Column_TldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLD`)
};

const en_tld_pricing_column_tld = /** @type {(inputs: Tld_Pricing_Column_TldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TLD`)
};

/**
* | output |
* | --- |
* | "TLD" |
*
* @param {Tld_Pricing_Column_TldInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_column_tld = /** @type {((inputs?: Tld_Pricing_Column_TldInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Column_TldInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_column_tld(inputs)
	return id_tld_pricing_column_tld(inputs)
});